/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MenuItemsDto as DigiworkMaitreDPosDtoMenuItemsMenuItemsDto } from '../../models/Digiwork/MaitreD/Pos/DTO/MenuItems/menu-items-dto';

export interface GetMostOrderedItems_1$Params {
  venueId: string;
}

export function getMostOrderedItems_1(http: HttpClient, rootUrl: string, params: GetMostOrderedItems_1$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDPosDtoMenuItemsMenuItemsDto>> {
  const rb = new RequestBuilder(rootUrl, getMostOrderedItems_1.PATH, 'get');
  if (params) {
    rb.path('venueId', params.venueId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DigiworkMaitreDPosDtoMenuItemsMenuItemsDto>;
    })
  );
}

getMostOrderedItems_1.PATH = '/api/menu-categories/{venueId}/menu-items/most-ordered-items';
